import { render, staticRenderFns } from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=template&id=8b22197e&scoped=true&"
import script from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAnalysisParametersDiagnosticLimitsTable.vue?vue&type=style&index=0&id=8b22197e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b22197e",
  null
  
)

export default component.exports